export default __webpack_public_path__ + "media/images/users/user-sam-kromstain-270x298-dd3d457ae5e7390aa3b8cbce539c55cb.jpg";